<ul [class.mobile-expanded]="mobileExpanded()">
  @for (item of nav().children; track item) {
    <li>
      @if (item.url && item.label) {
        <a
          (click)="currentUrl.set(item.url); mobileExpanded.set(true)"
          [queryParams]="item.queryParams"
          [routerLink]="item.url"
          >
          <mat-card mat-ripple>
            @if (item.icon) {
              <ui-icon
                [faName]="item.icon.name"
                [faStyle]="item.icon.family"
              ></ui-icon>
            }
            <span class="link-labels">
              <span><strong>{{ item.label }}</strong></span>
              @if (item.description) {
                <span class="mat-body-1">{{ item.description }}</span>
              }
            </span>
          </mat-card>
        </a>
      }
    </li>
  }
</ul>
